var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 641,
    height: 365.02,
    viewBox: "0 0 641 365.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4866",
    "data-name": "Group 4866",
    transform: "translate(41 -80.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21229",
    "data-name": "Path 21229",
    d: "M578.543,371.177c0,66.382-39.463,89.561-88.144,89.561s-88.144-23.178-88.144-89.561S490.4,220.346,490.4,220.346,578.543,304.794,578.543,371.177Z",
    transform: "translate(-241.241 -138.077)",
    fill: "#66b512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21230",
    "data-name": "Path 21230",
    d: "M379.085,364.535l.9-55.557,37.569-68.731-37.428,60.016.406-24.981,25.892-49.726-25.785,43.116h0l.73-44.928L409.1,184.156l-27.612,32.523.456-82.382-2.866,109.059.236-4.5-28.19-43.149,27.738,51.785-2.627,50.177-.078-1.332-32.5-45.408,32.4,50.113-.329,6.275-.059.094.027.515-6.664,127.3h8.9l1.068-65.755,32.319-49.99Z",
    transform: "translate(-133.139 -52.029)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21231",
    "data-name": "Path 21231",
    d: "M717.375,473.528c0,66.383-39.463,89.561-88.144,89.561s-88.144-23.178-88.144-89.561S629.231,322.7,629.231,322.7,717.375,407.145,717.375,473.528Z",
    transform: "translate(-295.027 -177.73)",
    fill: "#2b6636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21232",
    "data-name": "Path 21232",
    d: "M517.917,466.885l.9-55.556L556.389,342.6l-37.427,60.016.406-24.98,25.893-49.726-25.786,43.115h0l.73-44.929,27.726-39.588L520.319,319.03l.456-82.383-2.866,109.06.236-4.5-28.19-43.149,27.738,51.785-2.627,50.177-.078-1.332-32.5-45.407,32.4,50.113-.328,6.275-.059.094.027.515-6.664,127.3h8.9l1.068-65.755,32.319-49.989Z",
    transform: "translate(-186.924 -91.681)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21233",
    "data-name": "Path 21233",
    d: "M446.8,473.528c0,66.383-39.463,89.561-88.144,89.561s-88.144-23.178-88.144-89.561S358.661,322.7,358.661,322.7,446.8,407.145,446.8,473.528Z",
    transform: "translate(-190.204 -177.73)",
    fill: "#2b6636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21234",
    "data-name": "Path 21234",
    d: "M247.346,466.885l.9-55.556L285.819,342.6l-37.428,60.016.406-24.98,25.893-49.726L248.9,371.022h0l.73-44.929,27.726-39.588L249.748,319.03l.456-82.383-2.866,109.06.235-4.5-28.189-43.149,27.737,51.785L244.5,400.021l-.078-1.332-32.5-45.407,32.4,50.113-.328,6.275-.059.094.027.515-6.664,127.3h8.9l1.068-65.755,32.32-49.989Z",
    transform: "translate(-82.101 -91.681)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21235",
    "data-name": "Path 21235",
    d: "M434.554,582.542A182.22,182.22,0,1,1,563.4,529.171a182.22,182.22,0,0,1-128.849,53.371Zm0-363.049c-99.709,0-180.829,81.119-180.829,180.829s81.12,180.829,180.829,180.829,180.829-81.12,180.829-180.829-81.12-180.829-180.829-180.829Z",
    transform: "translate(-183.152 -137.201)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21236",
    "data-name": "Path 21236",
    d: "M465.18,550.159v77.6H167.207v-77.6l148.986-77.6.311.161Z",
    transform: "translate(-64.778 -183.078)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21237",
    "data-name": "Path 21237",
    d: "M559.6,550.261v77.6H410.923V472.825Z",
    transform: "translate(-159.198 -183.179)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21238",
    "data-name": "Path 21238",
    d: "M382.576,539.136,371.4,543.355V526.721l11.174-4.9Z",
    transform: "translate(-143.887 -202.162)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21239",
    "data-name": "Path 21239",
    d: "M185.626,619.55l-3.725,1.408v-10.1l3.725-1.647Z",
    transform: "translate(-70.471 -236.018)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21240",
    "data-name": "Path 21240",
    d: "M206.514,611.9l-4.346,1.629v-10.94l4.346-1.908Z",
    transform: "translate(-78.323 -232.712)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21241",
    "data-name": "Path 21241",
    d: "M229.428,602.21l-4.966,1.868v-11.8l4.966-2.186Z",
    transform: "translate(-86.96 -228.61)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21242",
    "data-name": "Path 21242",
    d: "M257.018,590.723l-6.208,2.343V580.791l6.208-2.724Z",
    transform: "translate(-97.168 -223.952)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21243",
    "data-name": "Path 21243",
    d: "M290.687,576.813l-7.449,2.815V566.26l7.449-3.268Z",
    transform: "translate(-109.731 -218.111)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21244",
    "data-name": "Path 21244",
    d: "M331.451,560.483l-8.691,3.274V548.689l8.691-3.81Z",
    transform: "translate(-125.042 -211.094)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21245",
    "data-name": "Path 21245",
    d: "M185.626,652.9l-3.725.937V643.584l3.725-1.178Z",
    transform: "translate(-70.471 -248.878)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21246",
    "data-name": "Path 21246",
    d: "M206.514,647.315l-4.346,1.088v-11.02l4.346-1.37Z",
    transform: "translate(-78.323 -246.401)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21247",
    "data-name": "Path 21247",
    d: "M229.428,640.717l-4.966,1.248v-11.8l4.966-1.566Z",
    transform: "translate(-86.96 -243.528)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21248",
    "data-name": "Path 21248",
    d: "M257.018,632.987l-6.208,1.559V621.813l6.208-1.953Z",
    transform: "translate(-97.168 -240.143)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21249",
    "data-name": "Path 21249",
    d: "M290.687,623.227l-7.449,1.88V611.432l7.449-2.343Z",
    transform: "translate(-109.731 -235.97)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21250",
    "data-name": "Path 21250",
    d: "M331.058,611.937l-9.312,2.342V598.9l9.312-2.93Z",
    transform: "translate(-124.649 -230.888)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21251",
    "data-name": "Path 21251",
    d: "M382.576,597.614,371.4,600.423V583.336l11.174-3.505Z",
    transform: "translate(-143.887 -224.635)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21252",
    "data-name": "Path 21252",
    d: "M382.576,655.472,371.4,656.894V639.952l11.174-2.113Z",
    transform: "translate(-143.887 -247.108)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21253",
    "data-name": "Path 21253",
    d: "M185.626,685.619l-3.725.479v-9.79l3.725-.71Z",
    transform: "translate(-70.471 -261.737)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21254",
    "data-name": "Path 21254",
    d: "M206.514,683.134l-4.346.548V673.2l4.346-.815Z",
    transform: "translate(-78.323 -260.492)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21255",
    "data-name": "Path 21255",
    d: "M229.428,679.225l-4.966.629v-11.8l4.966-.946Z",
    transform: "translate(-86.96 -258.446)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21256",
    "data-name": "Path 21256",
    d: "M257.018,674.629l-6.208.793V662.834l6.208-1.184Z",
    transform: "translate(-97.168 -256.333)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21257",
    "data-name": "Path 21257",
    d: "M290.687,669.642l-7.449.945V656.606l7.449-1.419Z",
    transform: "translate(-109.731 -253.829)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21258",
    "data-name": "Path 21258",
    d: "M331.058,663.569l-9.312,1.177V649.291l9.312-1.767Z",
    transform: "translate(-124.649 -250.86)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21259",
    "data-name": "Path 21259",
    d: "M633.865,619.55l3.725,1.408v-10.1l-3.725-1.647Z",
    transform: "translate(-245.569 -236.018)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21260",
    "data-name": "Path 21260",
    d: "M612.584,611.9l4.346,1.629v-10.94l-4.346-1.908Z",
    transform: "translate(-237.324 -232.712)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21261",
    "data-name": "Path 21261",
    d: "M589.277,602.21l4.966,1.868v-11.8l-4.966-2.186Z",
    transform: "translate(-228.295 -228.61)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21262",
    "data-name": "Path 21262",
    d: "M560.9,590.723l6.208,2.343V580.791l-6.208-2.724Z",
    transform: "translate(-217.302 -223.952)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21263",
    "data-name": "Path 21263",
    d: "M526.448,576.813l7.449,2.815V566.26l-7.449-3.268Z",
    transform: "translate(-203.954 -218.111)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21264",
    "data-name": "Path 21264",
    d: "M484.9,560.483l8.691,3.274V548.689l-8.691-3.81Z",
    transform: "translate(-187.857 -211.094)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21265",
    "data-name": "Path 21265",
    d: "M633.865,652.9l3.725.937V643.584l-3.725-1.178Z",
    transform: "translate(-245.569 -248.878)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21266",
    "data-name": "Path 21266",
    d: "M612.584,647.315l4.346,1.088v-11.02l-4.346-1.37Z",
    transform: "translate(-237.324 -246.401)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21267",
    "data-name": "Path 21267",
    d: "M589.277,640.717l4.966,1.248v-11.8l-4.966-1.566Z",
    transform: "translate(-228.295 -243.528)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21268",
    "data-name": "Path 21268",
    d: "M560.9,632.987l6.208,1.559V621.813l-6.208-1.953Z",
    transform: "translate(-217.302 -240.143)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21269",
    "data-name": "Path 21269",
    d: "M526.448,623.227l7.449,1.88V611.432l-7.449-2.343Z",
    transform: "translate(-203.954 -235.97)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21270",
    "data-name": "Path 21270",
    d: "M484.9,611.937l9.312,2.342V598.9l-9.312-2.93Z",
    transform: "translate(-187.857 -230.888)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21271",
    "data-name": "Path 21271",
    d: "M432.2,597.614l11.174,2.809V583.336L432.2,579.831Z",
    transform: "translate(-167.442 -224.635)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21272",
    "data-name": "Path 21272",
    d: "M432.2,655.472l11.174,1.422V639.952L432.2,637.839Z",
    transform: "translate(-167.442 -247.108)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21273",
    "data-name": "Path 21273",
    d: "M633.865,685.619l3.725.479v-9.79l-3.725-.71Z",
    transform: "translate(-245.569 -261.737)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21274",
    "data-name": "Path 21274",
    d: "M612.584,683.134l4.346.548V673.2l-4.346-.815Z",
    transform: "translate(-237.324 -260.492)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21275",
    "data-name": "Path 21275",
    d: "M589.277,679.225l4.966.629v-11.8l-4.966-.946Z",
    transform: "translate(-228.295 -258.446)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21276",
    "data-name": "Path 21276",
    d: "M560.9,674.629l6.208.793V662.834L560.9,661.65Z",
    transform: "translate(-217.302 -256.333)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21277",
    "data-name": "Path 21277",
    d: "M526.448,669.642l7.449.945V656.606l-7.449-1.419Z",
    transform: "translate(-203.954 -253.829)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21278",
    "data-name": "Path 21278",
    d: "M484.9,663.569l9.312,1.177V649.291l-9.312-1.767Z",
    transform: "translate(-187.857 -250.86)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21279",
    "data-name": "Path 21279",
    d: "M442.365,543.438l-11.174-4.214V521.711l11.174,4.9Z",
    transform: "translate(-167.05 -202.119)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5812",
    "data-name": "Rectangle 5812",
    width: 0.911,
    height: 14.573,
    transform: "translate(379.325 430.861)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5813",
    "data-name": "Rectangle 5813",
    width: 0.645,
    height: 10.326,
    transform: "translate(390.322 434.828)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5814",
    "data-name": "Rectangle 5814",
    width: 0.567,
    height: 9.076,
    transform: "translate(399.936 436.089)",
    fill: "#66b512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21280",
    "data-name": "Path 21280",
    d: "M561.8,694.316v18.748l-12.1-.018-12.105-.019V691.957l12.105,1.18Z",
    transform: "translate(-208.272 -268.074)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21281",
    "data-name": "Path 21281",
    d: "M244.73,713.064l24.21-.039V691.957l-24.21,2.357Z",
    transform: "translate(-94.812 -268.074)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5815",
    "data-name": "Rectangle 5815",
    width: 641,
    height: 1.5,
    transform: "translate(-41 444.368)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21282",
    "data-name": "Path 21282",
    d: "M569.461,695.062V713.81l-12.1-.018V693.883Z",
    transform: "translate(-215.928 -268.821)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5816",
    "data-name": "Rectangle 5816",
    width: 1.242,
    height: 17.382,
    transform: "translate(248.932 427.918)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21283",
    "data-name": "Path 21283",
    d: "M549.647,761.523c0,6.091-3.254,11.174-7.165,11.348-3.8.17-6.808-4.388-6.808-10.176s7.429-21.678,7.429-21.678S549.647,755.432,549.647,761.523Z",
    transform: "translate(-292.93 -339.794)",
    fill: "#66b512"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5817",
    "data-name": "Rectangle 5817",
    width: 0.741,
    height: 10.368,
    transform: "translate(103.372 433.488)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21284",
    "data-name": "Path 21284",
    d: "M310.468,779.926c0,3.633-1.941,6.665-4.274,6.769-2.268.1-4.061-2.617-4.061-6.07s4.431-12.93,4.431-12.93S310.468,776.293,310.468,779.926Z",
    transform: "translate(-202.453 -350.129)",
    fill: "#66b512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21285",
    "data-name": "Path 21285",
    d: "M760.853,781.045c0,3.455-2.177,6.154-5.01,6.021-3.007-.141-5.585-3.385-5.585-7.237s5.585-13.477,5.585-13.477S760.853,777.59,760.853,781.045Z",
    transform: "translate(-376.063 -349.609)",
    fill: "#66b512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21286",
    "data-name": "Path 21286",
    d: "M778.157,789.954c0,2.448-1.543,4.361-3.55,4.267-2.131-.1-3.957-2.4-3.957-5.128s3.957-9.549,3.957-9.549S778.157,787.506,778.157,789.954Z",
    transform: "translate(-383.963 -354.719)",
    fill: "#66b512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21287",
    "data-name": "Path 21287",
    d: "M793.661,792.73c0,2.152-1.356,3.833-3.12,3.75-1.873-.088-3.478-2.108-3.478-4.507s3.478-8.393,3.478-8.393S793.661,790.578,793.661,792.73Z",
    transform: "translate(-390.322 -356.283)",
    fill: "#66b512"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqHome);
export default __webpack_public_path__ + "static/media/faq_home.5183ba8f6be0e7661e1d079f387104c2.svg";
export { ForwardRef as ReactComponent };